import SelectedVariants from './SelectedVariants';
import TextField from '../../audi-ui-components/TextField';
import Checkbox from '../../audi-ui-components/Checkbox';
import RadioFieldset from '../../audi-ui-components/RadioFieldset';
import CheckboxGroup from '../../components/CheckboxGroupField';
import Button from '../../audi-ui-components/Button';
import Disclaimer from '../../components/Disclaimer';
import ReturnToButton from '../../components/ReturnToButton';
import Spinner from '../../audi-ui-components/Spinner';
import DealerByPostcodeModule from '../../components/DealerByPostcodeModule';
import { formatMobile } from '../../functions/textFormatting';
import classnames from 'classnames';
import _findIndex from 'lodash/findIndex';
import {
    LABEL_OPTIN,
    PLANNING_TO_BUY_OPTIONS,
    PREF_CONTACT_OPTIONS
} from '../../constants';

const RYIForm = ({
  values, errors, touched, submitCount, isSubmitting,
  setValues, setFieldValue, setFieldTouched,
  ryiVariants,
  showVariantOpts,
  isLocked,
  isPrefilled,
  preSelectedVariant,
  submittedData,
  scrollToError,
  query,
  theme,
}) => {
  
  if (submittedData && submittedData.modelVariants) {
    return (
      <div className="row justify-content-center">
        <div className="col-12 col-small-6 col-large-5 text-center pb-5">
          {!submittedData.dealerName && <p className="aui-font-extended mb-5">
            Thank you for your interest. We look forward to sharing updates on the {submittedData?.modelVariants?.length === 1 ? <b>{submittedData.modelVariants[0].name}</b> : <>vehicles you selected</>} as they become available.
          </p>}
          {submittedData.dealerName && <p className="aui-font-extended mb-5">
            Thank you for your interest. <b>{submittedData.dealerName}</b> will be in touch with you soon.
          </p>}
          <div className="pb-5"><ReturnToButton query={query} /></div>
        </div>
      </div>
    );
  }
  
  return (
    <>
    <div className="row">
      <div className={classnames("col-12 col-small-7", {"col-large-6": isLocked})}>
        {values.dealerContact && <>
          <h4 className="aui-headline-4 mb-2">{(isLocked && preSelectedVariant) ? <b className="d-medium-none">{`${preSelectedVariant.name} - `}</b> : ""}Request dealer contact</h4>
          {isPrefilled && <p className="mb-3 mb-small-5">Ensure your details are correct below, and your chosen dealer will contact you shortly.</p>}
          {!isPrefilled && <p className="mb-3 mb-small-5">Enter your details below, and your chosen dealer will contact you shortly.</p>}
        </>}
        {!values.dealerContact && <>
          <h4 className="aui-headline-4 mb-2">{(isLocked && preSelectedVariant) ? <b className="d-medium-none">{`${preSelectedVariant.name} - `}</b> : ""}Keep me informed</h4>
          {isPrefilled && <p className="mb-3 mb-small-5">Ensure your details are correct below, so we can keep you updated with the latest information on your selected model(s).</p>}
          {!isPrefilled && <p className="mb-3 mb-small-5">Enter your details so we can keep you updated with the latest information on your selected model(s).</p>}
        </>}
        
        {!showVariantOpts && <div className="d-small-none">
          <SelectedVariants selected theme={theme} isLocked={isLocked} isDealerContact={values.dealerContact} value={values.variantIds} options={ryiVariants} onChange={(v) => {
            setFieldValue('variantIds', v);
            setFieldTouched('variantIds');
          }} />
        </div>}
        {showVariantOpts && <div>
          <CheckboxGroup name="modelVariantNames"
            label="I am interested in:"
            value={values.modelVariantNames}
            options={ryiVariants}
            delimeter="|"
            checkboxClassName="d-block mb-3 aui-font-extended"
            onChange={(v) => { setFieldValue('modelVariantNames', v); }}
            onBlur={() => { setFieldTouched('modelVariantNames'); }}
            isInvalid={errors.modelVariantNames && (touched.modelVariantNames || submitCount > 0)}
            invalidMessage={errors.modelVariantNames}
            theme={theme === "dark" ? "light" : null}
          />
        </div>}
        <div className="row">
          <div className="col-12 col-small-6">
            <TextField name="firstName"
                label="First name *"
                value={values.firstName}
                onChange={(v) => { setFieldValue('firstName', v); }}
                isInvalid={errors.firstName && (touched.firstName || submitCount > 0)}
                invalidMessage={errors.firstName}
                onBlur={() => { setFieldTouched('firstName'); }}
                className="form-field"
                theme={theme === "dark" ? "light" : null}
            />
          </div>
          <div className="col-12 col-small-6">
            <TextField name="lastName"
                label="Last name *"
                value={values.lastName}
                onChange={(v) => { setFieldValue('lastName', v); }}
                isInvalid={errors.lastName && (touched.lastName || submitCount > 0)}
                invalidMessage={errors.lastName}
                onBlur={() => { setFieldTouched('lastName'); }}
                className="form-field"
                theme={theme === "dark" ? "light" : null}
            />
          </div>
        </div>
        <TextField name="emailAddress"
            label="Email address*"
            value={values.emailAddress}
            onChange={(v) => { setFieldValue('emailAddress', v.trim()); }}
            isInvalid={errors.emailAddress && (touched.emailAddress || submitCount > 0)}
            invalidMessage={errors.emailAddress}
            onBlur={() => { setFieldTouched('emailAddress'); }}
            className="form-field"
            theme={theme === "dark" ? "light" : null}
        />
        <TextField name="postCode"
            label="Postcode *"
            value={values.postCode}
            onChange={(v) => {
              let _v = v.trim();
              setFieldValue('postCode', _v);
              if (!values.dealerPostcode && /^\d{4}$/.test(_v)) { setFieldValue('dealerPostcode', _v, false); }
            }}
            isInvalid={errors.postCode && (touched.postCode || submitCount > 0)}
            invalidMessage={errors.postCode}
            onBlur={() => {
              setFieldTouched('postCode');
            }}
            className="form-field"
            theme={theme === "dark" ? "light" : null}
        />
        {values.dealerContact &&
          <CheckboxGroup name="preferredContactMethod"
            label="Your preferred contact method*"
            value={values.preferredContactMethod}
            options={PREF_CONTACT_OPTIONS}
            delimeter=";"
            checkboxClassName="me-5 mb-3"
            onChange={(v) => { setFieldValue('preferredContactMethod', v); }}
            onBlur={() => { setFieldTouched('preferredContactMethod'); }}
            isInvalid={errors.preferredContactMethod && (touched.preferredContactMethod || submitCount > 0)}
            invalidMessage={errors.preferredContactMethod}
            theme={theme === "dark" ? "light" : null}
          />
        }
        {(!values.dealerContact || (values.preferredContactMethod?.indexOf("Phone") > -1 || values.preferredContactMethod?.indexOf("SMS") > -1)) &&
          <TextField name="mobilePhone"
              label="Mobile number"
              value={values.mobilePhone}
              onChange={(v) => { v = formatMobile(v); setFieldValue('mobilePhone', v); }}
              isInvalid={errors.mobilePhone && (touched.mobilePhone || submitCount > 0)}
              invalidMessage={errors.mobilePhone}
              onBlur={() => { setFieldTouched('mobilePhone'); }}
              className="form-field"
              theme={theme === "dark" ? "light" : null}
          />
        }
        {values.dealerContact && <>
          <DealerByPostcodeModule
            values={values}
            errors={errors}
            touched={touched}
            setFieldValue={setFieldValue}
            setValues={setValues}
            setFieldTouched={setFieldTouched}
            postcodeName="dealerPostcode"
            formName="ryi"
            updateOnExtChange
            theme={theme}
          />
          <RadioFieldset name="planningToBuyCar"
            label="When are you looking to buy?*"
            value={values.planningToBuyCar}
            options={PLANNING_TO_BUY_OPTIONS}
            onChange={(v) => { setFieldValue('planningToBuyCar', v); }}
            onBlur={() => { setFieldTouched('planningToBuyCar'); }}
            isInvalid={errors.planningToBuyCar && (touched.planningToBuyCar || submitCount > 0)}
            invalidMessage={errors.planningToBuyCar}
            className="form-field"
            theme={theme === "dark" ? "light" : null}
          />
        </>}
        <Checkbox name="optIn"
            label={<>{LABEL_OPTIN}*</>}
            checked={!!values.optIn}
            value=""
            onChange={(v,e) => { setFieldValue('optIn', e.target.checked); }}
            onBlur={() => { setFieldTouched('optIn'); }}
            isInvalid={errors.optIn && (touched.optIn || submitCount > 0)}
            invalidMessage={errors.optIn}
            className="form-field"
            theme={theme === "dark" ? "light" : null}
        />
        {process.env.RAZZLE_APP_ENV === 'local' && <div className="form-field dev-only">
          <Checkbox
            name="submitToBackend"
            label="Submit to backend"
            checked={!!values.submitToBackend}
            value=""
            onChange={(v,e) => { setFieldValue('submitToBackend', e.target.checked); }}
          />
        </div>}
        <div className="form-field submit">
            {errors.modelVariants && submitCount > 0 && <p className="aui-color-text-red submit-error mb-1">{errors.modelVariants}</p>}
            {errors.submit && <p className="aui-color-text-red submit-error mb-2">{errors.submit}</p>}
            <Button type="submit" variant="primary" theme={theme === "dark" ? "light" : null} isStretched onClick={scrollToError}>
              {values.dealerContact ? "Request dealer contact" : "Submit"}
            </Button>
        </div>
        <p className="mb-3 aui-small">All fields marked with * are mandatory.</p>
        <Disclaimer />
      </div>
      {!showVariantOpts && <div className={classnames("d-none d-small-block", {"col-5 offset-large-1": isLocked, "col-5 col-large-4 offset-large-1": !isLocked})}>
        <SelectedVariants selected theme={theme} isLocked={isLocked} isDealerContact={values.dealerContact} value={values.variantIds} options={ryiVariants} onChange={(v) => {
          setFieldValue('variantIds', v);
          setFieldTouched('variantIds');
        }} />
      </div>}
    </div>
    {isSubmitting && <div className="spinner-wrapper sticky"><Spinner isContinuous /></div>}
    </>
  );
}

export default RYIForm;
